module.exports = __webpack_public_path__ + "images/emoji/cold_sweat.e6e2d4c1e2f64b0d4108.png";